module.exports = __webpack_public_path__ + "img/supervision_240.27a948d1.webp";